/**=========================================================
 * Module: translations.js
 * Translations Controller
 =========================================================*/

App.controller('TranslationsController',
    ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 
        'Restangular', 'DataService', 'ngDialog', '$filter', 'LocalRestangular',
        function ($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, ngDialog, $filter, LR) {
            "use strict";

            $scope.type = 'translation';
            $scope.filter = $state.params.filter;

            $scope.translationsLastT = 0;
            $scope.listenToTranslationsChanges = function(){
                FIREBASE.listen('Translation', $scope.project.id, function(value){
                    if(value && FIREBASE.isAfter(value.timestamp,$scope.translationsLastT) && $scope.translationsLastT>0){
                        $scope.init();
                    }
                }, null, { interval: 60000 });
            }

            var langToLocale = function(lang){
                lang = lang.replace(/_/g, '-')
                lang = lang.split('-')
                if(lang.length>1){
                    lang[lang.length-1] = lang[lang.length-1].toUpperCase()
                }
                lang = lang.join('-')
                return $rootScope.mqLanguageCode(lang)
            }

            $scope.hadThisStatus = function (t, s) {
                if ($scope.statuses.indexOf(t.status) > $scope.statuses.indexOf(s)) return true;
                else return false;
            }
            $scope.willHaveThisStatus = function (t, s) {
                if ($scope.statuses.indexOf(t.status) < $scope.statuses.indexOf(s)) return true;
                else return false;
            }

            $scope.popupFileList = function(files, title, params){

                var scope = $scope.$new();
                scope.files = files;
                scope.title = title;
                scope.params = params
                ngDialog.open({
                        template: '/app/views/entities/file-popuplist.html',
                        className: 'ngdialog-theme-default',
                        scope: scope,
                        cache: false
                    });
    
            };

            if($state.params.action=='oneclick'){
                $scope.openExplorer = function(path){
                    LR.one('explorer', path).get().then(function(){}).catch(console.error);
                 }

                $scope.statusesT = {}
                $scope.statusesD = {}
                $scope.downloaded = {}
                $scope.uploaded = {}
                $scope.startedUpload = {}
                $scope.syncResult = {}
                $scope.upSyncResult = {}
                $scope.toBeUploaded = {}
                $scope.toBeUploadedForPopup = {}
                $scope.fields = {}
                $scope.upfields = {}
                $scope.loadedForPopup = {}
                $scope.$on('$syncEvent', function(event, data) { 
                    var d = data.scope.form.model.destination
                    if(data.scope.field.name=='translation'){
                        $scope.statusesT[d] = data.event
                    } else { 
                        $scope.statusesD[d] = data.event
                    }
                    if(data.event=='downloaded') {
                        $scope.downloaded[d] = true
                        $timeout(syncAll, 1000)
                    }
                    if(data.event=='uploaded') {
                        $scope.uploaded[d] = true
                        $scope.startedUpload[d] = true
                        $timeout(upSyncAll, 1000)
                    }
                    if(data.event=='nothingtoupload') {
                        $scope.startedUpload[d] = true
                        $timeout(upSyncAll, 1000)
                    }
                    if(data.event=='downloading') $scope.downloaded[d] = false
                    if(data.event=='loaded' && data.scope.field.name=='translation'){
                        $scope.syncResult[d] = data.scope.syncResult
                        $scope.fields[d] = data.scope.field
                        $scope.syncResult[d].finished = []
                        for(var i=0; i<data.scope.files.length; i++){
                            var file = data.scope.files[i]
                            var lf = data.scope.field.localFiles.filter(function(f){ return f.path.endsWith('\\' + file.name) || f.path.endsWith('/' + file.name) })
                            if(lf.length){
                                $scope.syncResult[d].finished.push(lf[0])
                            }
                        }
                        $scope.loadedForPopup[d] = $scope.syncResult[d].finished
                    }
                    if(data.event=='loaded' && data.scope.field.name==$scope.upSyncFieldName){
                        $scope.toBeUploaded[d] = data.scope.field.toBeUploaded
                        $scope.upfields[d] = data.scope.field
                        $scope.toBeUploadedForPopup[d] = data.scope.field.localFiles.filter(function(f){
                            return data.scope.field.toBeUploaded.find(function(u) { return u==f.path })
                        })
                    }
                })

                var clickOnSync = function(id){
                    $timeout(function () { angular.element('#SyncDownload_'+id+'_translation').triggerHandler('click') }, 100)
                }
                var clickOnUpSync = function(id){
                    $timeout(function () { angular.element('#SyncUpload_'+id+'_'+$scope.upSyncFieldName).triggerHandler('click') }, 100)
                }

                var syncAll = function(){
                    for(var ti=0; ti<$scope.translations.length; ti++){
                        var t = $scope.translations[ti]
                        if(t.status=='IMPORT' && !$scope.statusesT[t.destination]){
                            clickOnSync(t.id) 
                            break
                        }
                        $scope.syncing = false
                    }
                }
                var upSyncAll = function(){
                    for(var ti=0; ti<$scope.translations.length; ti++){
                        var t = $scope.translations[ti]
                        if(t.status=='IMPORT' && !$scope.startedUpload[t.destination]){
                            clickOnUpSync(t.id) 
                            break
                        }
                        $scope.upsyncing = false
                    }
                }

                $scope.startSyncAll = function(){
                    $scope.syncing = true
                    $scope.startedSyncing = true
                    $scope.statusesT = {}
                    $scope.downloaded = {}
                    $scope.syncResult = {}
                    syncAll()
                }
                $scope.startUpSyncAll = function(){
                    $scope.upsyncing = true
                    $scope.startedUpsyncing = true
                    $scope.statusesD = {}
                    $scope.uploaded = {}
                    $scope.startedUpload = {}
                    $scope.upSyncResult = {}
                    upSyncAll()
                }
            }
            $scope.uploadForms = {}
            $scope.downloadForms = {}
            
            var loadT = function(index){
                D.query('file', 'type=translation&entityId='+$scope.translations[index].id+'&field=translation', { cache: false }).then(
                    function(response){
                        $scope.translations[index].downloadFiles = response;
                        $scope.translations[index].syncField = {
                            name: 'translation',
                            sync: {
                                download: true,
                                folder: $scope.translations[index].opts && $scope.translations[index].opts.reviewStatus=='reviewed' ? 'reviewTarget' : 'translationTarget',
                                lang: $rootScope.mqLanguageCode($scope.translations[index].destination)
                            },
                            bucket: $rootScope.bucketName($scope.project.group)
                        }
                        
                    }
                    ).catch(function(err){
                        $scope.statusesD[$scope.translations[index].destination]='error'
                    });
                    $scope.downloadForms[$scope.translations[index].destination] = {
                        model: $scope.translations[index]
                    }
                    $scope.uploadForms[$scope.translations[index].destination] = {
                        title: $scope.project.dtp ? 'labels.LOADFILESFORDTP' : 'labels.LOADFILESNODTP',
                        titleParams: { lang: $scope.translations[index].destination},
                        status: 'notsubmittable',
                        type: 'translation',
                        model: $scope.translations[index],
                        refreshFile: function(data){
                            if($rootScope.files['translation'+this.model.id+($scope.upSyncFieldName)].length>0 && this.status=='notsubmittable')
                                this.status = '';
                            if(this.status=='' && $scope.uploaded[this.model.destination] && $scope.toBeUploaded[this.model.destination] && $rootScope.files['translation'+this.model.id+($scope.upSyncFieldName)].length==$scope.toBeUploaded[this.model.destination].length){
                                $scope.uploaded[this.model.destination] = false
                                this.submit()
                            }
                        },
                        fields: [
                            {
                                available: true,
                                type: 'file',
                                name: $scope.upSyncFieldName,
                                canUpload: true,
                                noLabel: true,
                                inputColumn: 12,
                                limit: -1,
                                sync: {
                                        folder: ($scope.project.dtp ? 'dtpSource' : 'delivery'), 
                                        upload: true,
                                        lang: $rootScope.mqLanguageCode($scope.translations[index].destination),
                                        code: $scope.project.code,
                                        parentmodel: $scope.project
                                },
                                alwaysShowLocalFilesToUpload: true,
                                bucket: $rootScope.bucketName($scope.project.group),
                                filesSelectable: $rootScope.user.admin,
                                selectionActions: [
                                    { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                ] 
                            },{
                                available: true,
                                type: 'submit',
                                name: 'empty',
                                label: $scope.project.dtp ? 'labels.SENDLAYOUT' : 'labels.SENDDELIVERY',
                                labelColumn: 0
                            }
                        ],
                        submit: function(){
                            this.status = 'submitting';
                            $scope.statusesD[this.model.destination]='uploading'
                            this.model.action = $scope.project.dtp ? 'layout' : 'deliver';
                            var self = this
                            D.save('translation', this.model).then(
                                function(response){
                                    $scope.upSyncResult[self.model.destination] = response
                                    $scope.statusesD[self.model.destination]='uploaded'
                                    $scope.translations[index] = response
                                }
                                
                            ).catch(function(response){
                                    $scope.statusesD[self.model.destination]='error'
                                });

                        }
                    };
            }

            $scope.initialized = false;
            $scope.watchActivated = false;
            $scope.init = function () {

                if ($rootScope.user.id) {
                    $scope.initialized = true;


                    $scope.byStatus = {}
                    D.query($scope.type, 'project=' + $scope.filter, { cache: false }).then(
                        function (response) {
                            $scope.translations = response;

                            for(var ti=0; ti<$scope.translations.length; ti++){
                                var t = $scope.translations[ti];
                                $scope.translationsLastT = t.T > $scope.translationsLastT ? t.T : $scope.translationsLastT;
                                $scope.byStatus[t.status] = $scope.byStatus[t.status] ? $scope.byStatus[t.status].concat(t) : [t];
                                
                                

                            }

                            D.load('project', $scope.filter, { cache:false }).then(
                                function (response) {
                                    $scope.project = response;
                                    
                                    if($state.params.action!='oneclick'){
                                        $scope.listenToTranslationsChanges();
                                    }

                                    if (!$scope.project.dtp) {
                                        $scope.statuses = ['TRANSLATION', 'IMPORT', 'DELIVERED'];
                                        $scope.agent = [$scope.project.supplierName, 'Aqrate', $scope.project.groupName];
                                    } else {
                                        $scope.statuses = ['TRANSLATION', 'IMPORT', 'LAYOUT', 'REVISION', 'DELIVERED'];
                                        $scope.agent = [$scope.project.supplierName, 'Aqrate', $scope.project.supplierName, 'Aqrate', $scope.project.groupName];
                                    }

                                    for(var ti=0; ti<$scope.translations.length; ti++){
                                        var t = $scope.translations[ti]
                                        for(var si in $scope.statuses){
                                            var s = $scope.statuses[si]
                                            if($scope.hadThisStatus(t, s)){
                                                $scope.byStatus['HAD'+s] = $scope.byStatus['HAD'+s] ? $scope.byStatus['HAD'+s].concat(t) : [t];
                                            }
                                            if($scope.willHaveThisStatus(t, s)){
                                                $scope.byStatus['WILL'+s] = $scope.byStatus['WILL'+s] ? $scope.byStatus['WILL'+s].concat(t) : [t];
                                            }
                                        }

                                        if($state.params.action=='oneclick'){
                                            $scope.upSyncFieldName = $scope.project.dtp ? 'layout' : 'delivery'
                                            if(t.status=='IMPORT'){
                                                loadT(ti)
                                            }
                                        }
                                        
                                    }

                                    $scope.forms = {};
                                    if ($rootScope.user.groupType == 'SUPPLIER') {
                                        $scope.df = {
                                            'TRANSLATION': {
                                                type: 'project',
                                                field: 'analysis:upload',
                                                ext: 'xliff|tmx|zip|mqxlz|mqxliff',
                                                entity: $scope.project.id
                                            },
                                            'LAYOUT': {
                                                type: 'project',
                                                field: 'translation:layout',
                                                ext: '',
                                                entity: $scope.project.id
                                            },
                                            /*'LAYOUT_': {
                                                type: 'project',
                                                field: 'analysis:upload',
                                                ext: 'xliff|tmx|zip|mqxlz|mqxliff',
                                                entity: $scope.project.id
                                            },*/
                                            'DELIVERED': {
                                                type: 'project',
                                                field: 'translation:' + ($scope.project.dtp ? 'revision' : 'translation'),
                                                ext: '',
                                                entity: $scope.project.id
                                            }
                                        }
                                        $scope.forms = {
                                            /*'LAYOUT': {
                                                title: 'labels.LOADTRANSLATIONLAYOUT',
                                                titleParams: { lang: 'all'},
                                                status: 'notsubmittable',
                                                type: 'translation',
                                                model: $scope.project,
                                                refreshFile: function(data){
                                                    if($rootScope.files['translation'+this.model.id+'revision'].length>0)
                                                        this.status = '';
                                                },
                                                fields: [
                                                    {
                                                        available: true,
                                                        type: 'submit',
                                                        name: 'empty',
                                                        label: 'labels.SENDREVISION',
                                                        labelColumn: 0,
                                                        cls: 'btn-lg pulse-button'
                                                    },
                                                    {
                                                        available: true,
                                                        type: 'file',
                                                        name: 'revision',
                                                        canUpload: true,
                                                        noLabel: true,
                                                        inputColumn: 12,
                                                        limit: -1
                                                    }
                                                ],
                                                submit: function(){
                                                    this.status = 'submitting';
                                                    this.model.action = 'revision';
                                                    D.save('translation', this.model).then(
                                                        function(response){
                                                            $scope.model = response;
                                                            $scope.currentStatusIndex = $scope.statuses.indexOf($scope.model.status);
                                                            $scope.uploadForm.status = 'notsubmittable';
                                                            $scope.uploadForm.showSuccess=true;
                                                        },
                                                        function(response){
                                                            $scope.uploadForm.status = 'error';
                                                        }
                                                    );

                                                }
                                            };*/
                                        }
                                    }
                                    if ($rootScope.user.groupType == 'CLIENT') {
                                        $scope.df = {
                                            'IMPORT': {
                                                type: 'project',
                                                field: 'translation:translation',
                                                ext: '',
                                                entity: $scope.project.id
                                            },
                                            'LAYOUT': {
                                                type: 'project',
                                                field: 'translation:layout',
                                                ext: '',
                                                entity: $scope.project.id
                                            },
                                            /*'LAYOUT_': {
                                                type: 'project',
                                                field: 'analysis:upload',
                                                ext: 'xliff|tmx|zip|mqxlz|mqxliff',
                                                entity: $scope.project.id
                                            },*/
                                            'DELIVERED': {
                                                type: 'project',
                                                field: 'translation:revision|translation:delivery',
                                                ext: '',
                                                entity: $scope.project.id
                                            }
                                        }
                                    }
                                    if ($rootScope.user.groupType == 'ADMIN') {
                                        $scope.df = {
                                            'TRANSLATION': {
                                                type: 'project',
                                                field: 'analysis:upload',
                                                ext: 'xliff|tmx|zip|mqxlz|mqxliff',
                                                entity: $scope.project.id
                                            },
                                            'IMPORT': {
                                                type: 'project',
                                                field: 'translation:translation',
                                                ext: '',
                                                entity: $scope.project.id
                                            },
                                            'LAYOUT': {
                                                type: 'project',
                                                field: 'translation:layout',
                                                ext: '',
                                                entity: $scope.project.id
                                            },
                                            /*'LAYOUT_': {
                                                type: 'project',
                                                field: 'analysis:upload',
                                                ext: 'xliff|tmx|zip|mqxlz|mqxliff',
                                                entity: $scope.project.id
                                            },*/
                                            'REVISION': {
                                                type: 'project',
                                                field: 'translation:revision',
                                                ext: '',
                                                entity: $scope.project.id
                                            },
                                            'DELIVERED': {
                                                type: 'project',
                                                field: 'translation:revision|translation:delivery',
                                                ext: '',
                                                entity: $scope.project.id,
                                                sync: {
                                                    download: true,
                                                    folder: 'delivery',
                                                    //copyTo: $scope.project.dtp ? ['dtpTarget'] : [],
                                                    lang: '*',
                                                    noUnzip: true
                                                },
                                                bucket: $rootScope.bucketName($scope.project.group) 
                                            }
                                        }
                                    }
                                    $scope.statusesIcons = {
                                        'TRANSLATION': 'language',
                                        'IMPORT': 'indent',
                                        'LAYOUT': 'columns',
                                        'REVISION': 'clipboard',
                                        'DELIVERED': 'archive'
                                    }
                                    

                                    $scope.page = {
                                        title: 'labels.TRANSLATIONOF',
                                        titleParams: {
                                            projectName: $scope.project.name
                                        },
                                        subTitle: $scope.project.code

                                    };

                                    $scope.hasFiles = {}
                                    
                                    var loadFiles = function (s) {
                                        if ($scope.df[s]) {
                                            $scope.hasFiles[s] = true
                                            $scope.df[s].name = $scope.project.code + '_' + $filter('translate')('enums.translationStatus.'+s).replace(/\s/g,'_')
                                            D.query('file', 'type=' + $scope.df[s].type + '&field=' + $scope.df[s].field + ($scope.df[s].ext ? '&extension=' + $scope.df[s].ext : '') + '&entityId=' + $scope.df[s].entity, { cache: false })
                                                .then(function (response) {
                                                    let s_ = s + '_'
                                                    if (response.length === 0 && $scope.df[s_]) {
                                                        $scope.df[s] = $scope.df[s_]
                                                        D.query('file', 'type=' + $scope.df[s].type + '&field=' + $scope.df[s].field + ($scope.df[s].ext ? '&extension=' + $scope.df[s].ext : '') + '&entityId=' + $scope.df[s].entity, { cache: false })
                                                            .then(function (response) {
                                                                $scope.files[s] = response
                                                                $scope.totalSizes[s] = 0
                                                                for(var fi=0; fi<$scope.files[s].length; fi++){
                                                                    var f = $scope.files[s][fi];
                                                                    f.name = langToLocale(f.entity.split('-')[f.entity.split('-').length-1]) + '/' + f.name
                                                                    if($scope.project.destinations.length==1) f.name = f.name.split('/')[1]
                                                                    $scope.totalSizes[s] += f.size
                                                                }
                                                            }).catch(console.error)
                                                    }
                                                    $scope.files[s] = response
                                                    $scope.totalSizes[s] = 0
                                                    for(var fi=0; fi<$scope.files[s].length; fi++){
                                                        var f = $scope.files[s][fi]
                                                        f.name = langToLocale(f.entity.split('-')[f.entity.split('-').length-1]) + '/' + f.name
                                                        if($scope.project.destinations.length==1) f.name = f.name.split('/')[1]
                                                        $scope.totalSizes[s] += f.size
                                                    }
                                                }).catch(console.error)
                                        }
                                    }

                                    $scope.files = {}
                                    $scope.totalSizes = {}
                                    for (var i in $scope.statuses) {
                                        var s = $scope.statuses[i];
                                        loadFiles(s)
                                    }

                                }).catch(console.error)
                        }).catch(console.error)


                } else {
                    if (!$scope.watchActivated) {
                        $scope.watchActivated = true;
                        $rootScope.$watch('user.id', function () {
                            if (!$scope.initialized) {
                                $scope.init();
                            }
                        });
                    }
                }
            }

            $scope.init();



        }
    ]);